import { DefaultFetchService } from "app/services/fetchService";
import queryString from "query-string";


interface IGeographyApiService {
    getDomainsGeographyTableData: (params: {
        country: string;
        from: string;
        to: string;
        includeSubDomains: boolean;
        isWindow: boolean;
        timeGranularity: string;
        webSource: string;
        keys: string;
        orderBy: string;
        includeRegionalDomains: boolean;
    }) => Promise<any>;
}


export default class GeographyApiService implements IGeographyApiService {
    protected fetchService;

    constructor() {
        this.fetchService = DefaultFetchService.getInstance();
    }

    public getDomainsGeographyTableData(params: any): Promise<any> {
        const apiParams: any = {
            includeSubDomains: params.includeSubDomains,
            keys: params.key,
            from: params.from,
            to: params.to,
            country: "999", //params.country,
            webSource: params.webSource,
            isWindow: params.isWindow,
            timeGranularity: "Monthly",
            orderBy: params.orderBy,
            page: 1,
            pageSize: 200,
            includeRegionalDomains: params.includeRegionalDomains,
        };
        return this.fetchService.get(`widgetApi/WebsiteGeographyExtended/GeographyExtended/Table`, apiParams);
    }

    public getDomainsGeographyTableExcelUrl(params: any): string {
        const queryStringParams = queryString.stringify(params);
        return `/widgetApi/WebsiteGeographyExtended/GeographyExtended/Excel?${queryStringParams}`;
    }
}
